import { TResidentialStatus } from '../SignupForm/SignupForm.types';

type TResidentialOptions = { label: string; value: TResidentialStatus };

export const RESIDENTIAL_OPTIONS: TResidentialOptions[] = [
  { label: 'Tenant', value: 'tenant' },
  { label: 'Owner occupier (with mortgage)', value: 'owner_with_mortgage' },
  { label: 'Owner occupier (no mortgage)', value: 'owner_no_mortgage' },
  { label: 'Living rent free (e.g. with parents)', value: 'rent_free' },
];
